export default function() {
    return {
        post: {
            roles: [null]
        },
        success: false,
        customToolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }], ["image"]],
        availableStatuses: [
            {
                label: 'Publicado',
                value: '1'
            },
            {
                label: 'Rascunho',
                value: '0'
            }
        ],
        availableRoles: [
            {
                label: 'Prestador',
                value: 'ROLE_PROFESSIONAL'
            },
            {
                label: 'Contratante',
                value: 'ROLE_CONTRACTOR'
            },
            {
                label: 'Todos',
                value: null
            }
        ],
        errors: {
            title: null,
            content: null,
            status: null
        }
    }
}
